module.exports = __webpack_public_path__ + "static/media/connect.54bfc10e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/connect.svg
// module id = 1090
// module chunks = 0